import { saveAs } from 'file-saver'
import DateUtils from '@/utils/DateUtils'

/**
 * ダウンロード関連メソッド
 */
export default class DownloadUtils {
  /**
   * 通常生徒一覧CSVダウンロード時のファイル名
   *
   * @returns ファイル名(.csv)
   */
  public static fileNameStudentsCsv(): string {
    return `students_${DateUtils.getTimestamp()}.csv`
  }

  /**
   * 仮生徒一覧CSVダウンロード時のファイル名
   *
   * @returns ファイル名(.csv)
   */
  public static fileNameTemporaryStudentsCsv(): string {
    return `temporary_students_${DateUtils.getTimestamp()}.csv`
  }

  /**
   * csv形式でのダウンロード
   *
   * @param content テキストデータ(blob型)
   * @param fileName ファイル名
   */
  public static csv(content: string | Blob, fileName: string): void {
    // contentがstringだった場合、blobに変換(運用上あまり発生しないが、メソッドの汎用性を鑑みstringも受け取れるようにしておく)
    // 変換時に、各行の不要なインデントや空白を削除する
    if (typeof content === 'string') {
      content = new Blob(
        [
          content
            .split('\n')
            .map((line) => line.trim())
            .join('\n'),
        ],
        { type: 'text/csv' }
      )
    }

    // ファイルに変換
    const file = new File([content], fileName, { type: 'text/csv' })

    // 保存
    saveAs(file)
  }

  /**
   * pdf系式でのダウンロード
   *
   * @param content Blob系式PDFデータ
   * @param fileName ファイル名
   */
  public static pdf(content: Blob, fileName: string): void {
    // ファイルに変換
    const file = new File([content], fileName, { type: 'application/pdf' })

    // 保存
    saveAs(file)
  }
}
